import type { ForumBase } from '../types/forum';

/** Sponsorluk aktif mi (süre dolmuşsa hayır). */
export function isSponsorActive(forum: Pick<ForumBase, 'is_sponsored' | 'sponsored_until'>): boolean {
  if (!forum.is_sponsored) return false;
  if (!forum.sponsored_until) return true;
  const end = new Date(forum.sponsored_until);
  if (Number.isNaN(end.getTime())) return true;
  return end.getTime() >= Date.now();
}

export function formatSponsorUntil(iso: string | null | undefined): string | null {
  if (!iso) return null;
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch {
    return null;
  }
}
